module.exports = __webpack_public_path__ + "static/media/img_snake_end_left.ef41aa0a.svg";